// @flow
import React from 'react';
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';

const Inner = styled.p`
  margin-top: 15px;
  ${getFont('-2')}
`;

export const Disclaimer = () => (
  <Inner>
    Las respuestas publicadas en esta sección son de carácter informativo y genérico y no constituyen una recomendación
    personalizada de inversión. Las decisiones que los clientes adopten y los resultados de las inversiones realizadas
    no serán responsabilidad de FINECT. Toda inversión contiene riesgos y rentabilidades pasadas no son garantía de
    rentabilidades futuras.
  </Inner>
);
